import React from 'react';
import { withRouter, Redirect, RouteComponentProps } from 'react-router';
import { adminConsoleFallbackPath, useAdminConsoleRoutesMap } from '../admin-console-side-nav/admin-console-routes-map';

export const AdminConsoleFallbackPage = withRouter(({ match }: RouteComponentProps) => {
  const { routeGroups } = useAdminConsoleRoutesMap(match.path);
  const firstVisible = routeGroups
    .flatMap((group) => group.routeOptions)
    .find((option) => option.label !== '' && option.enabled !== false);

  return <Redirect to={firstVisible?.route ?? `${match.path}/${adminConsoleFallbackPath}`} />;
});
